import { FormControl } from '@angular/forms';
import { GrocyBasics } from '../../../../core/entities/grocy/shared/basics.entity';
import { positiveOrZeroNotNull, required, requiredNotNull } from '../../../../forms/form-control-options.constants';
import { BaseFormControls } from '../../../../forms/form-controls/base.form-controls';

export class GrocyDashboardShoppingSessionFormControls extends BaseFormControls {
  date = new FormControl(new Date(), requiredNotNull);
  store = new FormControl<GrocyBasics | null>(null, required);
  totalPrice = new FormControl(0.0, positiveOrZeroNotNull);
}
